"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantResumeWebView = ApplicantResumeWebView;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_use_1 = require("react-use");
const elements_1 = require("@src/components/elements");
const Holder_1 = require("@src/components/elements/Holder/Holder");
const ApplicantResumeWebViewMain_1 = require("./ApplicantResumeWebViewMain");
function ApplicantResumeWebView() {
    const [ref, { width }] = (0, react_use_1.useMeasure)();
    return ((0, jsx_runtime_1.jsx)(Holder_1.HolderWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Panel, { measureRef: ref, className: "p-m", children: (0, jsx_runtime_1.jsx)(ApplicantResumeWebViewMain_1.ApplicantResumeWebViewMain, { mainWidth: width }) }) }));
}
